export default __webpack_public_path__ + "static/media/hedgewall.d989593e.png";